import { createVNode as o, mergeProps as l } from "vue";
import m from "../node_modules/@pf-ui/pf-icon-svg/es/asn/RequireFilled.js";
import s from "../components/PfIcon.js";
const e = (r, t) => {
  const i = {
    ...r,
    ...t.attrs
  };
  return o(s, l(i, {
    icon: m
  }), null);
};
e.displayName = "RequireFilled";
e.inheritAttrs = !1;
export {
  e as default
};
